import { LencoImage } from '@/atomic-components/Image';
import { Box, Grid, SxProps, Theme } from '@mui/material';
// import { styled } from '@mui/system';
import React, { useState, MouseEvent, useRef, useEffect } from 'react';
import { FreeMode, Navigation, HashNavigation, History } from 'swiper';
import { Swiper, SwiperRef, SwiperSlide, useSwiper } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';
import ZoomIcon from '@/assets/pdp/zoom.svg';
import { Thumbnail } from '../Inclusions/modal';
// import { ZoomGlass } from './styles';
// import { useRouter } from 'next/router';
import { getColor } from '@/utils/theme/colors';
import SwiperButton from '../../../../assets/pdp/imageSwiperButton.svg';
import LencoButton from '@/atomic-components/LencoButton';
import ImageGalleryDrawer from '../ImageGallery';
import { ProductApiData } from '@/services/catalogue/models/pdp';
import ImageThumbnailSelector from './ImageThumbnailSelector';
import FlexBox from '@/atomic-components/FlexBox';
import ProductBadgeComponent from '@/components/ProductBadge';
import { emitMoeEvent } from '@/utils/dataLayer';
import { getPdpEventAttributes } from '@/utils/pdp';
import useBadgeData from '@/hooks/useBadge';
// import FlexBox from '@/atomic-components/FlexBox';

export interface IProductImagesSliderProps {
	images: Thumbnail[];
	productDetails: ProductApiData;
}

const GLASS_DEFAULTS = { top: 0, left: 0 };

const ProductImagesSlider = (props: IProductImagesSliderProps) => {
	// const router = useRouter();
	const [isZoomedViewVisible, setIsZoomedViewVisible] = useState(false);
	const [selectedImageToView, setSelectedImageToView] =
		useState<Thumbnail | null>();

	const closeImageGalleryDrawer = () => {
		setSelectedImageToView(null);
	};

	const onImageClicked = (image: Thumbnail) => {
		setSelectedImageToView(image);
	};
	// const [zoomGlassPosition, setZoomGlassPosition] =
	// 	useState<SxProps<Theme>>(GLASS_DEFAULTS);

	const onHoverOverImage = (event: MouseEvent<HTMLImageElement>) => {
		event.stopPropagation();
		setIsZoomedViewVisible(true);
	};

	function onImageSelection(_: Thumbnail, index: number) {
		if (document.querySelector('.hero-slider')) {
			const swiper = (document.querySelector('.hero-slider') as any).swiper;
			swiper.slideTo(index + 2);
		}
	}

	// const zoomOut = (event: MouseEvent<HTMLImageElement>) => {
	// 	setIsZoomedViewVisible(false);
	// 	setZoomGlassPosition(GLASS_DEFAULTS);
	// };

	const [currentSlide, setCurrentSlide] = useState<number>(0);
	const swiperRef = React.useRef<SwiperRef>(null);
	const badgeData = useBadgeData();

	const getProductBadge = () => {
		if (props?.productDetails?.badge?.name) {
			return (
				<Box
					sx={{
						zIndex: 2,
						height: '0px',
						position: 'relative',
						left: '-8px',
						top: '24px',
					}}
				>
					<ProductBadgeComponent badge={props.productDetails.badge} badgesInfo={badgeData} />
				</Box>
			);
		}
	};

	useEffect(() => {
		if (!!selectedImageToView) {
			emitMoeEvent(
				'PDP Full Image Viewed',
				getPdpEventAttributes({ productDetails: props.productDetails })
			);
		}
	}, [selectedImageToView]);

	return (
		<Grid sx={{ background: 'white' }} display='flex' flexDirection='column'>
			{getProductBadge()}
			<ImageGalleryDrawer
				open={!!selectedImageToView}
				onClose={closeImageGalleryDrawer}
				defaultImage={selectedImageToView!}
				images={props.images}
				productDetails={props.productDetails}
			/>
			<Box sx={{ position: 'relative' }}>
				<Box sx={{ position: 'relative' }}>
					{swiperRef && !isZoomedViewVisible && (
						<LencoButton
							onClick={(e) => {
								swiperRef?.current?.swiper?.slidePrev();
							}}
							sx={{
								transform: 'rotate(180deg)',
								position: 'absolute',
								zIndex: 9,
								top: '40%',
								left: '-10px',
								tranform: 'translate(-50%)',
								cursor: 'pointer',
							}}
						>
							<SwiperButton />
						</LencoButton>
					)}
					<Box
						sx={{
							zIndex: 1,
						}}
					>
						<>
							<Swiper
								ref={swiperRef}
								loop={true}
								spaceBetween={8}
								modules={[Navigation]}
								grabCursor={true}
								slidesPerView={1.5}
								className='hero-slider'
								onSlideChange={(e) => {
									// console.log(e.activeIndex);
									setCurrentSlide(e.activeIndex);
								}}
							>
								{props.images?.map((item, index) => {
									return (
										<SwiperSlide
											style={{
												alignSelf: 'center',
												marginRight: '8px',
												background:
													'linear-gradient(180deg, #FFFFFF 0.09%, #F3F3F3 100%)',
											}}
											data-hash={`slide-${index}`}
											key={item?.url}
										>
											<Box
												sx={{
													cursor: isZoomedViewVisible ? 'crosshair' : 'default',
												}}
												key={item?.url}
												onClick={() => onImageClicked(item)}
											>
												<LencoImage
													url={item?.url}
													alt-='slider image'
													aspectRatio={item.aspectRatio}
												/>
											</Box>
										</SwiperSlide>
									);
								})}
							</Swiper>
						</>
					</Box>
					{swiperRef && !isZoomedViewVisible && (
						<LencoButton
							onClick={(e) => {
								swiperRef?.current?.swiper?.slideNext();
							}}
							sx={{
								position: 'absolute',
								zIndex: 9,
								top: '40%',
								right: '-10px',
								cursor: 'pointer',
							}}
						>
							<SwiperButton />
						</LencoButton>
					)}

					<Box
						position='absolute'
						left='10px'
						bottom='0px'
						sx={{ cursor: 'pointer' }}
						zIndex='1'
						onMouseMove={(event: MouseEvent<HTMLImageElement>) =>
							onHoverOverImage(event)
						}
						onMouseLeave={() => setIsZoomedViewVisible(false)}
					>
						<ZoomIcon />
					</Box>
					<Box
						className={isZoomedViewVisible ? 'zooming' : ''}
						// sx={{ ...ZoomGlass, ...zoomGlassPosition }}
					></Box>
				</Box>
				<Grid container display='flex' marginTop='16px'>
					<ImageThumbnailSelector
						images={props.images}
						currentIndex={currentSlide}
						onImageSelection={onImageSelection}
					/>
				</Grid>
				{isZoomedViewVisible && (
					<FlexBox
						id='zoomed-preview'
						sx={{
							height: '640px',
							width: `${640 * props.images[currentSlide - 2]?.aspectRatio}px`,
							border: `1px solid ${getColor('Gray -4')}`,
							position: 'absolute',
							zIndex: 9,
							left: '100px',
							top: '0px',
							backgroundColor: 'white',
							justifyContent: 'center',
						}}
					>
						<img
							src={props.images[currentSlide - 2]?.url}
							style={{
								maxHeight: '640px',
								width: 'auto',
							}}
						/>
					</FlexBox>
				)}
			</Box>
		</Grid>
	);
};

export default ProductImagesSlider;
